<div [ngClass]="{ 'menu-open': offCanvasOpen }" class="sidebar-wrapper">
  <div class="menu-wrapper">
    <div (click)="handleMenu()" class="burger-menu text-center">
      <div
        [ngClass]="{ 'hamburger-active': offCanvasOpen }"
        class="hamburger-menu"
      >
        <div class="hamburger-icon-container" id="hamburger">
          <span class="hamburger-icon"></span>
        </div>
      </div>
    </div>
    <nav class="main-nav">
      <div
        (click)="vibrate()"
        class="nav-item"
        routerLink="/home"
        routerLinkActive="active"
      >
        <div class="icon">
          <svg
            height="23.846"
            viewBox="0 0 29.456 23.846"
            width="29.456"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              data-name="Gruppe 318"
              id="Gruppe_318"
              transform="translate(0 0)"
            >
              <g
                data-name="Gruppe 317"
                id="Gruppe_317"
                transform="translate(0 0)"
              >
                <path
                  d="M29.251,14.232,15.224.2a.7.7,0,0,0-.992,0L.206,14.232a.7.7,0,1,0,.992.992L14.727,1.693,28.26,15.224a.7.7,0,0,0,.992,0,.7.7,0,0,0,0-.992"
                  data-name="Pfad 145"
                  fill="#9c9c9c"
                  id="Pfad_145"
                  transform="translate(0 0)"
                />
                <path
                  d="M14.2,4.616a1.71,1.71,0,0,0-2.42,0l-8.9,8.9a1.4,1.4,0,0,0-.411.992v5.68a.751.751,0,0,0,.751.753H14.384a.707.707,0,0,0,.707-.707v-2.8a.7.7,0,0,1,.7-.7h1.4a.7.7,0,0,1,.7.7v2.809a.7.7,0,0,0,.7.7h4.159a.752.752,0,0,0,.753-.753v-5.68a1.4,1.4,0,0,0-.411-.992ZM22.1,19.536H19.3v-2.1a2.1,2.1,0,0,0-2.1-2.1h-1.4a2.1,2.1,0,0,0-2.1,2.1v2.1H3.869v-5.03l8.9-8.9a.3.3,0,0,1,.437,0l8.9,8.9Z"
                  data-name="Pfad 146"
                  fill="#9c9c9c"
                  id="Pfad_146"
                  transform="translate(1.743 2.908)"
                />
              </g>
            </g>
          </svg>
        </div>
        <span class="show-for-m">{{ "menu.home" | i18next }}</span>
      </div>
      <div
        (click)="vibrate()"
        class="nav-item"
        routerLink="/collections"
        routerLinkActive="active"
      >
        <div class="icon">
          <svg
            height="29.288"
            viewBox="0 0 29.288 29.288"
            width="29.288"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              data-name="Gruppe 384"
              id="Gruppe_384"
              transform="translate(0 0.001)"
            >
              <path
                d="M10.585,6.077V4.69a1.324,1.324,0,0,0-1.227-1.4H2.049A1.325,1.325,0,0,0,.822,4.69V6.077c0,6.712,2,9.26,4.185,9.69v4.258H2.914a.7.7,0,0,0,0,1.395H8.492a.7.7,0,0,0,0-1.395H6.4V15.767c2.186-.429,4.183-2.978,4.183-9.69m-8.368,0V4.682H9.19V6.077c0,5.24-1.3,8.368-3.486,8.368S2.217,11.317,2.217,6.077"
                data-name="Pfad 140"
                fill="#9c9c9c"
                id="Pfad_140"
                transform="translate(0.573 2.29)"
              />
              <path
                d="M11.705,21.418a.7.7,0,0,0,.7-.7V3.985a.7.7,0,0,0-.7-.7A3.487,3.487,0,0,0,8.218,6.774v6.277h2.79v7.67a.7.7,0,0,0,.7.7"
                data-name="Pfad 141"
                fill="#9c9c9c"
                id="Pfad_141"
                transform="translate(5.728 2.291)"
              />
              <path
                d="M15.815,21.418a.7.7,0,0,0,.7-.7V12.952C18.1,12.5,19.3,10.531,19.3,8.168c0-2.695-1.561-4.88-3.487-4.88s-3.487,2.186-3.487,4.88c0,2.362,1.2,4.331,2.79,4.784v7.769a.7.7,0,0,0,.7.7"
                data-name="Pfad 142"
                fill="#9c9c9c"
                id="Pfad_142"
                transform="translate(8.592 2.291)"
              />
              <path
                d="M28.591,16.437H.7a.7.7,0,0,0,0,1.395H28.591a.7.7,0,1,0,0-1.395"
                data-name="Pfad 143"
                fill="#9c9c9c"
                id="Pfad_143"
                transform="translate(0 11.455)"
              />
              <path
                d="M.7,1.395H28.591a.7.7,0,1,0,0-1.395H.7a.7.7,0,0,0,0,1.395"
                data-name="Pfad 144"
                fill="#9c9c9c"
                id="Pfad_144"
                transform="translate(0 -0.001)"
              />
            </g>
          </svg>
        </div>
        <span class="show-for-m">{{ "menu.collections" | i18next }}</span>
      </div>
      <div (click)="handleCart()" class="nav-item">
        <div class="icon">
          <svg
            data-name="Gruppe 387"
            height="35.226"
            id="Gruppe_387"
            viewBox="0 0 31.482 35.226"
            width="31.482"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g data-name="Gruppe 386" id="Gruppe_386">
              <path
                d="M31.414,28.13,28.48,8.186a2.475,2.475,0,0,0-2.435-2.1h-3.3A6.708,6.708,0,0,0,16.078,0h0a6.768,6.768,0,0,0-.99.08A6.818,6.818,0,0,0,14.1,0h0a6.7,6.7,0,0,0-6.67,6.084H5.433A2.472,2.472,0,0,0,3,8.191L.066,28.137a6.13,6.13,0,0,0-.066.9,6.2,6.2,0,0,0,6.189,6.19h19.1a6.12,6.12,0,0,0,.909-.068,6.2,6.2,0,0,0,5.214-7.028M21.744,6.084h-.98a6.639,6.639,0,0,0-1.933-4.122,6.865,6.865,0,0,0-.626-.547,5.717,5.717,0,0,1,3.539,4.669M15.086,1.1a5.615,5.615,0,0,1,4.648,4.988H10.439A5.612,5.612,0,0,1,15.086,1.1M10.063,2.67a5.7,5.7,0,0,1,1.909-1.258,6.829,6.829,0,0,0-.632.551A6.639,6.639,0,0,0,9.409,6.084H8.455A5.634,5.634,0,0,1,10.063,2.67m15.991,31.5a5.252,5.252,0,0,1-.763.056H6.189A5.2,5.2,0,0,1,1,29.036a5.129,5.129,0,0,1,.055-.754L3.993,8.335A1.467,1.467,0,0,1,5.434,7.084H9.379v3.557a1.011,1.011,0,0,0-.522.873,1.022,1.022,0,1,0,2.044,0,1.011,1.011,0,0,0-.522-.873V7.084h11.4v3.558a1.01,1.01,0,0,0-.522.872,1.022,1.022,0,1,0,2.044,0,1.01,1.01,0,0,0-.522-.873V7.084h3.266A1.469,1.469,0,0,1,27.49,8.332l2.935,19.944a5.2,5.2,0,0,1-4.371,5.894"
                data-name="Pfad 321"
                fill="#9c9c9c"
                id="Pfad_321"
              />
            </g>
          </svg>
          <div
            *ngIf="cartItemAmount > 0"
            [ngClass]="
              cartItemAmount > 0 && cartItemAmount < 100
                ? 'cart-counter'
                : cartItemAmount >= 100 && cartItemAmount < 1000
                ? 'cart-counter-100'
                : 'cart-counter-1000'
            "
          >
            {{ cartItemAmount }}
          </div>
        </div>
        <span class="show-for-m">{{ "menu.digital-bag" | i18next }}</span>
      </div>
    </nav>
  </div>
  <div class="hide-for-m">
    <svg
      height="64"
      viewBox="0 0 116 64"
      width="116"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g data-name="Gruppe 309" id="Gruppe_309" transform="translate(0.402 0)">
        <rect
          data-name="Rechteck 73"
          fill="#023e84"
          height="64"
          id="Rechteck_73"
          transform="translate(-0.402 0)"
          width="116"
        />
        <g data-name="Gruppe 191" id="Gruppe_191">
          <g data-name="Gruppe 190" id="Gruppe_190">
            <path
              d="M98.278,40.506l-.073-.37a82.425,82.425,0,0,1-14.225,1.23,82.427,82.427,0,0,1-14.22-1.23l-.071.372a67.469,67.469,0,0,0,14.292,1.521,67.491,67.491,0,0,0,14.3-1.523"
              data-name="Pfad 86"
              fill="#fff"
              id="Pfad_86"
              transform="translate(-26.385 -15.196)"
            />
            <path
              d="M100.605,43.489l-.073-.368a110.043,110.043,0,0,1-20.189,1.86,109.758,109.758,0,0,1-20.188-1.862l-.074.37a95.808,95.808,0,0,0,20.262,2.153,95.9,95.9,0,0,0,20.262-2.153"
              data-name="Pfad 87"
              fill="#fff"
              id="Pfad_87"
              transform="translate(-22.748 -16.326)"
            />
            <path
              d="M96.032,37.637l-.061-.371a68.06,68.06,0,0,1-8.494.529,67.961,67.961,0,0,1-8.495-.529l-.059.371a44.568,44.568,0,0,0,8.554.821,44.81,44.81,0,0,0,8.555-.821"
              data-name="Pfad 88"
              fill="#fff"
              id="Pfad_88"
              transform="translate(-29.881 -14.109)"
            />
            <path
              d="M89.645,17.283a3.147,3.147,0,0,0-3.059,3.464v7.288h.91V20.76c0-1.853,1.123-2.919,2.512-2.919a2.455,2.455,0,0,1,2.459,2.523h.183a2.992,2.992,0,0,0-3.005-3.082"
              data-name="Pfad 89"
              fill="#fff"
              id="Pfad_89"
              transform="translate(-32.783 -6.544)"
            />
            <path
              d="M89.563,16.026c2,0,3.617,1.44,3.617,4.027v7.289h.909V19.993c0-2.873-1.906-4.545-4.113-4.545a4.093,4.093,0,0,0-3.608,2.16l.143.078a3.614,3.614,0,0,1,3.052-1.66"
              data-name="Pfad 90"
              fill="#fff"
              id="Pfad_90"
              transform="translate(-32.7 -5.849)"
            />
            <path
              d="M95,80.783H94.6l-2.065,2.655v.293h1.809v1.143H95V83.731h.65v-.413H95Zm-.651,2.535H92.869l1.478-1.931Z"
              data-name="Pfad 91"
              fill="#fff"
              id="Pfad_91"
              transform="translate(-35.036 -30.586)"
            />
            <path
              d="M102.683,82.611c.408-.162.9-.425.9-.879,0-.575-.718-.861-1.257-.861-.687,0-1.427.328-1.427.992,0,.534.364.772.843.994-.487.251-.933.521-.933,1.089,0,.706.665,1.011,1.29,1.011.884,0,1.627-.377,1.627-1.15,0-.633-.446-.944-1.045-1.2M101.5,81.7c0-.449.365-.666.839-.666.449,0,.768.234.768.67a.927.927,0,0,1-.55.863c-.39-.2-1.057-.371-1.057-.867m.689,3.1a.793.793,0,0,1-.865-.827,1.169,1.169,0,0,1,.561-1.052c.526.232,1.226.406,1.226,1.052a.839.839,0,0,1-.922.827"
              data-name="Pfad 92"
              fill="#fff"
              id="Pfad_92"
              transform="translate(-38.168 -30.619)"
            />
            <path
              d="M80.727,84.5V80.87h-.112a2.361,2.361,0,0,1-1.2.616v.124c.369.032.546.032.605.127a.807.807,0,0,1,.052.371V84.5c0,.257-.142.292-.483.292v.12h1.58v-.12c-.352,0-.445-.035-.445-.292"
              data-name="Pfad 93"
              fill="#fff"
              id="Pfad_93"
              transform="translate(-30.069 -30.619)"
            />
            <path
              d="M86.293,80.836c-.137-.006-.185-.019-.185-.167h-.1l-.41,1.124h.145l.06-.167a.265.265,0,0,1,.253-.214H87.8l-1.286,2.576c-.238.465-.41.813-.41.837,0,.119.178.114.27.114a.389.389,0,0,0,.425-.282l1.447-3.648v-.162H86.8c-.164,0-.336,0-.506-.012"
              data-name="Pfad 94"
              fill="#fff"
              id="Pfad_94"
              transform="translate(-32.408 -30.543)"
            />
            <rect
              data-name="Rechteck 74"
              fill="#fff"
              height="0.373"
              id="Rechteck_74"
              transform="translate(13.707 46.097)"
              width="38.674"
            />
            <rect
              data-name="Rechteck 75"
              fill="#fff"
              height="0.373"
              id="Rechteck_75"
              transform="translate(56.596 46.097)"
              width="45.8"
            />
            <path
              d="M74.051,64.261a2.824,2.824,0,0,0,3.006,2.883,2.908,2.908,0,0,0,3.007-2.883,2.791,2.791,0,0,0-3.007-2.883,2.821,2.821,0,0,0-3.006,2.883m4.736,0c0,1.417-.592,2.575-1.729,2.575-1.174,0-1.728-1.146-1.728-2.575s.6-2.575,1.728-2.575c1.226,0,1.729,1.141,1.729,2.575"
              data-name="Pfad 95"
              fill="#fff"
              id="Pfad_95"
              transform="translate(-28.037 -23.239)"
            />
            <path
              d="M117.2,56.312v.267c.559.089,1.034-.039,1.034.61v7.075c0,.519-.56.519-1.034.544v.269c1.061,0,2.156.05,3.26.05a6.426,6.426,0,0,0,2.82-.483,2.13,2.13,0,0,0,1.319-1.969,2.353,2.353,0,0,0-2.28-2.312,1.985,1.985,0,0,0,1.673-2.006,1.875,1.875,0,0,0-1.076-1.676,6.051,6.051,0,0,0-2.651-.394c-1.048.013-2.06.013-3.065.025m5.943,6.427c0,1.312-.772,2.031-2.376,2.031-.684,0-1.145-.114-1.145-.775V60.74h.589c1.55,0,2.932.132,2.932,2m-.515-4.268c0,1.4-1.091,1.912-2.35,1.912h-.656V56.644c.127,0,.331,0,.455,0,2.064,0,2.551.828,2.551,1.827"
              data-name="Pfad 96"
              fill="#fff"
              id="Pfad_96"
              transform="translate(-44.372 -21.31)"
            />
            <path
              d="M134.695,67.145a2.91,2.91,0,0,0,3.006-2.884,2.791,2.791,0,0,0-3.006-2.883,2.886,2.886,0,1,0,0,5.767m0-5.459c1.225,0,1.73,1.141,1.73,2.575,0,1.417-.592,2.575-1.73,2.575-1.174,0-1.729-1.146-1.729-2.575s.6-2.575,1.729-2.575"
              data-name="Pfad 97"
              fill="#fff"
              id="Pfad_97"
              transform="translate(-49.859 -23.239)"
            />
            <path
              d="M25.043,65.271h.463l2.712-7.037c.318-.826.643-1.639,1.581-1.639v-.267H26.846V56.6c.314,0,.746-.027.976.4.126.23.091.711-.241,1.611L25.8,63.4h-.029l-2.2-5.513a1.853,1.853,0,0,1-.13-.785c.088-.4.572-.51,1.038-.51v-.267H20.6V56.6a1.331,1.331,0,0,1,.885.329,4.754,4.754,0,0,1,.718,1.412Z"
              data-name="Pfad 98"
              fill="#fff"
              id="Pfad_98"
              transform="translate(-7.799 -21.327)"
            />
            <path
              d="M44.861,64.782c-.587-.038-.769-.038-.769-.7V56.145c-.615.178-1.378.431-2.035.585v.152a.982.982,0,0,1,.6.191,1.052,1.052,0,0,1,.2.8v6.21c0,.661-.181.661-.81.7v.242h2.818Z"
              data-name="Pfad 99"
              fill="#fff"
              id="Pfad_99"
              transform="translate(-15.918 -21.257)"
            />
            <path
              d="M51.332,64.782c-.587-.038-.769-.038-.769-.7V56.145c-.615.178-1.378.431-2.036.585v.152a.982.982,0,0,1,.6.191,1.05,1.05,0,0,1,.2.8v6.21c0,.661-.182.661-.81.7v.242h2.817Z"
              data-name="Pfad 100"
              fill="#fff"
              id="Pfad_100"
              transform="translate(-18.369 -21.257)"
            />
            <path
              d="M68.7,61.957c.364,0,.5.5.926.5a.569.569,0,0,0,.575-.574c0-.414-.426-.652-.83-.652a2.015,2.015,0,0,0-1.639,1.141V61.286c-.573.2-1.245.468-1.831.646v.128c.488.214.641.241.641.738v3.212c0,.661-.18.661-.781.7v.242H68.66v-.242c-.711-.038-.894-.038-.894-.7v-2.45c0-1.037.526-1.6.94-1.6"
              data-name="Pfad 101"
              fill="#fff"
              id="Pfad_101"
              transform="translate(-24.9 -23.184)"
            />
            <path
              d="M146.681,67.145a2.537,2.537,0,0,0,2.419-1.606l-.208-.062a2.1,2.1,0,0,1-1.774,1.187c-1.5,0-1.883-1.308-1.883-2.477,0-1.017.3-2.5,1.588-2.5a.962.962,0,0,1,1.05.885.6.6,0,0,0,.562.636.514.514,0,0,0,.539-.52c-.033-.83-1.061-1.309-2.166-1.309a2.787,2.787,0,0,0-2.908,2.937,2.713,2.713,0,0,0,2.782,2.83"
              data-name="Pfad 102"
              fill="#fff"
              id="Pfad_102"
              transform="translate(-54.482 -23.239)"
            />
            <path
              d="M156.606,64.782c-.586-.038-.769-.038-.769-.7V60.718a1.779,1.779,0,0,1,1.468-.8c.775,0,1.193.638,1.193,1.481v2.686c0,.661-.183.661-.757.7v.242h2.791v-.242c-.615-.038-.8-.038-.8-.7V61.531a1.9,1.9,0,0,0-1.982-2.134,2.607,2.607,0,0,0-1.919.9V56.145c-.6.216-1.35.419-1.95.648v.1c.363.076.711.19.711.583v6.6c0,.661-.182.661-.81.7v.242h2.817Z"
              data-name="Pfad 103"
              fill="#fff"
              id="Pfad_103"
              transform="translate(-58.227 -21.257)"
            />
            <path
              d="M37.374,61.278c-.629.215-1.416.442-2.016.671v.127a1.425,1.425,0,0,1,.5.127c.251.153.251.507.251.775v3.047c0,.662-.181.662-.81.7v.242h2.84v-.242c-.587-.038-.768-.038-.768-.7Z"
              data-name="Pfad 104"
              fill="#fff"
              id="Pfad_104"
              transform="translate(-13.366 -23.201)"
            />
            <path
              d="M37.089,58.9a.719.719,0,1,0-.72-.718.719.719,0,0,0,.72.718"
              data-name="Pfad 105"
              fill="#fff"
              id="Pfad_105"
              transform="translate(-13.77 -21.754)"
            />
            <path
              d="M58.139,67.145a2.591,2.591,0,0,0,2.415-1.606l-.238-.062A2.276,2.276,0,0,1,58.5,66.664c-1.483,0-1.952-1.146-1.952-2.477a4.32,4.32,0,0,1,.048-.656h3.925a2.241,2.241,0,0,0-2.439-2.153,2.807,2.807,0,0,0-2.868,2.937,2.762,2.762,0,0,0,2.921,2.83m-.015-5.455c.581,0,1.156.5,1.156,1.458h-2.6c.238-.894.785-1.458,1.445-1.458"
              data-name="Pfad 106"
              fill="#fff"
              id="Pfad_106"
              transform="translate(-20.906 -23.239)"
            />
            <path
              d="M85.787,62.505l2.2,4.726-.444,1.028c-.114.261-.3.639-.634.609-.153-.012-.294-.064-.447-.075a.5.5,0,0,0-.531.52.561.561,0,0,0,.576.508c.8,0,1.117-.745,1.373-1.332l2.543-5.868a1.013,1.013,0,0,1,1.038-.775V61.6H89.17v.24c.236,0,.616-.016.78.242a.986.986,0,0,1-.077.8l-1.261,2.908-1.388-3.213a.671.671,0,0,1-.047-.489c.089-.244.385-.248.665-.248V61.6H84.924v.24c.516,0,.7.308.863.661"
              data-name="Pfad 107"
              fill="#fff"
              id="Pfad_107"
              transform="translate(-32.154 -23.324)"
            />
            <path
              d="M100.676,64.308a1.869,1.869,0,0,0,2.092,1.85,2.668,2.668,0,0,0,1.9-.9l.1.109a2.276,2.276,0,0,0,1.742.79,2.14,2.14,0,0,0,1.556-1.069l-.155-.135a1.087,1.087,0,0,1-.934.5,1.973,1.973,0,0,1-1.5-.784c-.059-.068-.123-.143-.188-.224.043-.071.085-.143.122-.213a12.234,12.234,0,0,0,.57-1.186c.217-.574.539-1.183,1.245-1.194v-.207h-2.116v.207c.364,0,.612.114.612.509a3.6,3.6,0,0,1-.574,1.654c-.02.036-.047.085-.085.142a28.689,28.689,0,0,1-1.609-2.488c.633-.454,1.324-.962,1.373-1.616.057-.754-.486-1.282-1.492-1.282a1.474,1.474,0,0,0-1.614,1.491,3.163,3.163,0,0,0,.354,1.133c.065.134.183.35.336.615-.767.528-1.741,1.214-1.741,2.3m2.688-5.25c.412,0,.779.244.721.94a1.966,1.966,0,0,1-.8,1.363c-.105-.188-.191-.35-.251-.47a2.329,2.329,0,0,1-.355-1.122.758.758,0,0,1,.688-.711m-.753,3.281a22.8,22.8,0,0,0,1.805,2.623,1.933,1.933,0,0,1-1.291.591,1.377,1.377,0,0,1-1.352-1.456,2.446,2.446,0,0,1,.838-1.758"
              data-name="Pfad 108"
              fill="#fff"
              id="Pfad_108"
              transform="translate(-38.117 -22.252)"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div (click)="openSearch()" class="hide-for-m">
    <svg
      height="29.647"
      viewBox="0 0 29.642 29.647"
      width="29.642"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        data-name="Gruppe 517"
        id="Gruppe_517"
        transform="translate(-332.358 -18.176)"
      >
        <g
          data-name="Gruppe 320"
          id="Gruppe_320"
          transform="translate(332.358 18.176)"
        >
          <g data-name="Gruppe 464" id="Gruppe_464">
            <path
              d="M29.436,28.442l-9.685-9.687a11.318,11.318,0,1,0-1,1l9.683,9.687a.706.706,0,0,0,1-1M11.292,21.173a9.881,9.881,0,1,1,9.881-9.881,9.892,9.892,0,0,1-9.881,9.881"
              data-name="Pfad 147"
              fill="#fff"
              id="Pfad_147"
            />
          </g>
        </g>
        <circle
          *ngIf="searchOpen"
          cx="6.5"
          cy="6.5"
          data-name="Ellipse 56"
          fill="#fff"
          id="Ellipse_56"
          r="6.5"
          transform="translate(337 23)"
        />
      </g>
    </svg>
  </div>
  <div class="menu-information">
    <div class="nav-item no-line">
      <app-status-indicator></app-status-indicator>
    </div>
    <div class="logo-nav">
      <img alt src="/assets/img/logo-nav.svg" />
    </div>
  </div>
  <div *ngIf="searchOpen" class="mobile-search hide-for-m">
    <app-search-filter></app-search-filter>
  </div>
</div>

<div [ngClass]="{ open: offCanvasOpen }" class="offcanvas">
  <div (click)="handleMenu()" class="burger-menu text-center hide-for-m">
    <div class="hamburger-menu hamburger-active close">
      <div class="hamburger-icon-container">
        <span class="hamburger-icon"></span>
      </div>
    </div>
  </div>
  <div class="menu">
    <div class="margin-b-2">
      <h2 class="upper">{{ "menu.service-menu" | i18next }}</h2>
      <a (click)="handleMenu()" routerLink="/pages/contact"
        >{{ "menu.contact" | i18next }}
      </a>
      <a
        (click)="handleMenu()"
        *ngIf="contextNative"
        routerLink="/pages/change-pin"
        >{{ "change-pin.change-pin" | i18next }}</a
      >
      <a
        *ngIf="b2bShopLink() && !nativeEnv"
        [href]="b2bShopLink()"
        target="_blank"
        >{{ "cart.b2b.name" | i18next }}</a
      >
      <a
        *ngIf="b2bShopLink() && nativeEnv"
        [href]="b2bShopLink()"
        target="_blank"
        (click)="openB2bNative()"
        >{{ "cart.b2b.name" | i18next }}</a
      >
      <a
        *ngIf="!b2bShopLink() && !nativeEnv"
        href="https://pro.villeroy-boch.com/de/de/dining-lifestyle/servicewelt-registrierung"
        target="_blank"
        >{{ "cart.b2b.name" | i18next }}</a
      >
      <a
        *ngIf="!b2bShopLink() && nativeEnv"
        href="https://pro.villeroy-boch.com/de/de/dining-lifestyle/servicewelt-registrierung"
        target="_blank"
        (click)="openB2bRegisterNative()"
        >{{ "cart.b2b.name" | i18next }}</a
      >
    </div>

    <div *ngIf="pricesVisibility" class="margin-b-3">
      <div class="flex-container align-center margin-b-1">
        <label class="switch shrink margin-0 margin-r-1">
          <input
            (change)="handlePriceActiv()"
            [checked]="priceActive"
            type="checkbox"
          />
          <span class="slider round"></span>
        </label>
        <div>{{ "menu.activate-prices" | i18next }}</div>
      </div>
      <div
        *ngIf="priceLists.length > 1"
        [ngClass]="{ 'hide-op': !priceActive }"
        class="price-lists margin-b-2"
      >
        {{ "menu.price-lists" | i18next }}
        <ng-container *ngFor="let priceList of this.priceLists; let i = index">
          <div
            (click)="openModal('change-pricelist-modal-' + i + '')"
            [ngClass]="{ active: selectedPriceList === priceList }"
            class="list-item"
          >
            <svg height="17" viewBox="0 0 21.359 21.359" width="17">
              <g
                data-name="Gruppe 280"
                id="Gruppe_280"
                transform="translate(-0.061 -0.061)"
              >
                <path
                  class="circle"
                  d="M21.859,11.18A10.68,10.68,0,1,1,11.179.5,10.68,10.68,0,0,1,21.859,11.18Z"
                  data-name="Pfad 56"
                  id="Pfad_56"
                  transform="translate(-0.439 -0.439)"
                />
                <path
                  class="checkmark"
                  d="M17.591,28.481,21.71,32.6l7.174-7.174"
                  data-name="Pfad 57"
                  fill="none"
                  id="Pfad_57"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  stroke-width="1"
                  transform="translate(-12.497 -18.025)"
                />
              </g>
            </svg>
            {{ priceListNameKeys[priceList] | i18next }}
          </div>
          <modal class="modal" id="change-pricelist-modal-{{ i }}">
            <div
              (click)="closeModal('change-priclist-modal-' + i)"
              class="close-button text-right"
            >
              <svg
                fill="none"
                height="24"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="cancel_24px">
                  <path
                    clip-rule="evenodd"
                    d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z"
                    fill-opacity="1"
                    fill-rule="evenodd"
                    id="icon/navigation/cancel_24px"
                  />
                </g>
              </svg>
            </div>
            <div class="text-center">
              <h1>{{ "menu.modal.pricelist-headline" | i18next }}?</h1>
              <p>{{ "menu.modal.pricelist-text" | i18next }}</p>
              <div class="flex-container">
                <button
                  (click)="closeModal('change-pricelist-modal-' + i)"
                  class="btn secondary"
                >
                  {{ "menu.modal.cancel" | i18next }}
                </button>
                <button
                  (click)="changePriceList(priceList, i)"
                  class="btn primary"
                >
                  {{ "menu.modal.change-price-list" | i18next }}
                </button>
              </div>
            </div>
          </modal>
        </ng-container>
      </div>
      <div class="price-info-txt margin-b-2">
        <small>{{ priceListTxt | i18next }}</small>
      </div>
    </div>
    <div class="legals margin-b-3">
      <h4 class="upper">{{ "menu.legals" | i18next }}</h4>
      <a (click)="handleMenu()" routerLink="/pages/privacy-policy">{{
        "menu.privacy-policy" | i18next
      }}</a>
      <a (click)="handleMenu()" routerLink="/pages/imprint">{{
        "menu.imprint" | i18next
      }}</a>
      <a (click)="handleMenu()" routerLink="/pages/terms-of-service">{{
        "menu.conditions" | i18next
      }}</a>
    </div>
    <div>
      <app-lang-switcher></app-lang-switcher>
      <button
        (click)="logout()"
        class="btn secondary small margin-t-2 margin-b-2"
      >
        {{ "menu.logout" | i18next }}
      </button>
      <div class="app-info">
        <small>Version: v{{ currentApplicationVersion }}</small
        ><br />
        <small *ngIf="dataService.context.processed"
          >Processed: {{ dataService.context.processed }}</small
        >
      </div>
    </div>
  </div>
</div>